export default __webpack_public_path__ + "static/media/NC_game_paths.3ed2b99b.png";